import { LoanStatusType } from "./loan-status.model";

export enum ZipLoanStatusType {
    Ready = 'ready_for_zip_disbursal',
    Initiated = 'zip_disbursal_initiated',
    Success = 'zip_disbursed',
    Failure = 'zip_disbursed_failed'
}

export class ZipLoanStatus {
    
    static isZipDisbursedLoan(loanSanctionStatus: LoanStatusType, loanDisbursalStatus: string): boolean {
        return ![LoanStatusType.Disbursed, LoanStatusType.DocumentHardcopyReceived].includes(loanSanctionStatus) && loanDisbursalStatus === ZipLoanStatusType.Success;
    }
}